import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NasModelModule } from '@sama/ng-app-state';
import { CrossTeamSharedModule } from '../../cross-team-shared/cross-team-shared.module';
import { ImageRendererComponent } from './image-renderer/image-renderer.component';
import { MissingShapeFeedbackMarkerComponent } from './missing-shape-feedback-marker/missing-shape-feedback-marker.component';
import { InteractiveBorderLineComponent } from './shape-parts/interactive-border/interactive-border-line.component';
import { InteractiveBorderComponent } from './shape-parts/interactive-border/interactive-border.component';
import { ModelInputPointsComponent } from './shape-parts/model-input-points/model-input-points.component';
import { ShapeFillComponent } from './shape-parts/shape-fill/shape-fill.component';
import { SvgTextComponent } from './shape-parts/svg-text/svg-text.component';
import { ArrowComponent } from './shapes/arrow/arrow.component';
import { CuboidComponent } from './shapes/cuboid/cuboid.component';
import { HairComponent } from './shapes/hair/hair.component';
import { KeypointShapeComponent } from './shapes/keypoint/keypoint-shape.component';
import { LineComponent } from './shapes/line/line.component';
import { PointComponent } from './shapes/point/point.component';
import { PolygonComponent } from './shapes/polygon/polygon.component';
import { RectangleComponent } from './shapes/rectangle/rectangle.component';
import { SliderRectangleComponent } from './shapes/slider-rectangle/slider-rectangle.component';
import { SubpointComponent } from './subpoint/subpoint.component';
import { CoordinatesBoxComponent } from './toolbars/coordinates-box/coordinates-box.component';
import { VectorTaggingLayerViewSettingsPopoverComponent } from './toolbars/layer-settings/vector-tagging/vector-tagging-layer-view-settings-popover.component';
import { VectorTaggingLayerViewSettingsComponent } from './toolbars/layer-settings/vector-tagging/vector-tagging-layer-view-settings.component';
import { ViewSettingsBrightnessSliderComponent } from './toolbars/layer-settings/view-settings-brightness-slider.component';
import { ViewSettingsContrastSliderComponent } from './toolbars/layer-settings/view-settings-contrast-slider.component';
import { ZoomPanelSettingsComponent } from './toolbars/layer-settings/zoom-panel-settings/zoom-panel-settings.component';
import { MainVectorTaggingToolbarComponent } from './toolbars/main-toolbars/main-vector-tagging-toolbar.component';
import { SecondaryToolbar2DComponent } from './toolbars/secondary-toolbar/secondary-toolbar-2d.component';
import { EditSecondaryToolbar2DComponent } from './tools/edit/edit-secondary-toolbar-2d.component';
import { KeypointSecondaryToolbarComponent } from './tools/keypoint/keypoint-secondary-toolbar.component';
import { PolygonSecondaryToolbarComponent } from './tools/polygon/polygon-secondary-toolbar.component';
import { ZoomSecondaryToolbarComponent } from './tools/zoom/zoom-secondary-toolbar.component';
import { VectorRendererComponent } from './vector-renderer/vector-renderer.component';

const secondaryToolbars2D = [
  EditSecondaryToolbar2DComponent,
  KeypointSecondaryToolbarComponent,
  PolygonSecondaryToolbarComponent,
  ZoomSecondaryToolbarComponent,
];

const exportedItems = [
  ArrowComponent,
  CuboidComponent,
  HairComponent,
  ImageRendererComponent,
  KeypointShapeComponent,
  LineComponent,
  MainVectorTaggingToolbarComponent,
  MissingShapeFeedbackMarkerComponent,
  ModelInputPointsComponent,
  PointComponent,
  PolygonComponent,
  RectangleComponent,
  SecondaryToolbar2DComponent,
  SliderRectangleComponent,
  VectorRendererComponent,
  VectorTaggingLayerViewSettingsPopoverComponent,
  VectorTaggingLayerViewSettingsComponent,
  ViewSettingsBrightnessSliderComponent,
  ViewSettingsContrastSliderComponent,
  ZoomPanelSettingsComponent,
];

@NgModule({
  imports: [
    BrowserModule,
    CrossTeamSharedModule,
    FontAwesomeModule,
    FormsModule,
    MatButtonToggleModule,
    MatTooltipModule,
    NasModelModule,
    CoordinatesBoxComponent,
  ],
  declarations: [
    exportedItems,
    secondaryToolbars2D,
    InteractiveBorderComponent,
    InteractiveBorderLineComponent,
    ShapeFillComponent,
    SubpointComponent,
    SvgTextComponent,
  ],
  exports: [exportedItems, CrossTeamSharedModule, CoordinatesBoxComponent],
})
export class Shared2DModule {}
